import { defineMessages } from 'react-intl';

export default defineMessages({
  text: {
    defaultMessage:
      'This action will {increase} your health factor! Always try to maintain a positive health factor to avoid liquidation.',
  },
  increase: { defaultMessage: 'increase' },
});
